import { useAuth } from '../contexts/AuthContext';

/**
 * Hook pour vérifier si l'utilisateur peut modifier (rôle autre que viewer).
 * Quand profile.role === 'viewer', tous les boutons d'action (sauf déconnexion) doivent être cachés/inactifs.
 */
export function useCanEdit() {
  const { profile } = useAuth();
  const isViewer = profile?.role === 'viewer';
  return {
    canEdit: !isViewer,
    isViewer: !!isViewer
  };
}
